module.exports = __webpack_public_path__ + "img/aa5.02601472.png";